import React from 'react'
export default function SmallRemoveIcon({ size = 24, width = size, height = size, fill, secondaryFill, stroke, secondaryStroke, children }) {
  return (<svg width={width} height={height} xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 64 64">{children}
<g fill={fill} stroke={stroke} className="nc-icon-wrapper"><path d="m44 17.171-12 12-12-12L17.171 20l12 12-12 12L20 46.829l12-12 12 12L46.829 44l-12-12 12-12z"/></g></svg>)
}
